import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'changeCampaignValidity'

export default ({ campaignId, validTo }) => (asyncAction(
  name,
  CampaignsService.changeCampaignValidity,
  { campaignId, validTo }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/changeCampaignValidity.js